import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { CoverImageGoldDate } from './components/CoverImage';
import { GoldListContainer } from './components/GoldListContainer';
import InfoContent from './components/InfoContent';

import { Loader, Modal } from '@/components';
import { Layout, MainHome } from '@/components/GenericsTournaments';
import { useCbuModal } from '@/hooks/useCbuModal';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useToast from '@/hooks/useToast';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { getInfoUsuarioOro } from '@/services/goldDate';
import { EnumContextGDT } from '@/types/team';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

export const MyGoldDateList = () => {
  const { tourneyData, updateTourney } = useTourney();
  const [mounted, setMounted] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();
  const { isMobile, isDesktop } = useIsDesktop();
  const { ModalCBU, setModalCBU } = useCbuModal();

  const { isLoading, data } = useQuery(
    'infoUsuarioOroListado',
    async () => await getInfoUsuarioOro(),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data.estado) {
          setMounted(true);
          updateTourney({
            tourney: data,
          });
        } else {
          if ('codError' in data && 'mensaje' in data) {
            toast.show(data.mensaje as string);
          }
        }
      },
      onError: (error) => {
        const err = error as Error;
        toast.showError(err);
      },
    }
  );

  //  effecto para levantar pop de carga de cbu
  useEffect(() => {
    data &&
      !data?.tieneDB &&
      mounted &&
      setTimeout(() => {
        setModalCBU({
          visibility: true,
          title: 'Fecha de Oro',
          returnPage: ROUTES.goldDate.list as keyof typeof ROUTES,
        });
      }, 1000);
  }, [data, setModalCBU, mounted]);

  const hideBack = useMemo(() => {
    return (
      data &&
      (data.estaPublicado ||
        (!data.inscripcionPosible && data.actualesSinPublicar)) &&
      !data.estaInactiva
    );
  }, [data]);

  return (
    <>
      <Loader isVisible={!mounted || isLoading} timeout={true} />
      <Layout
        adsSections={SECTION_NAME_FOR_ADS.fechadeoro}
        backButton={isDesktop && !hideBack}
        backButtonAction={() => navigate(ROUTES.goldDate.home)}
        className="p-4"
        coverTop={() => (
          <div className="lg:mt-6">
            <CoverImageGoldDate caption="Mis torneos Fecha de Oro" />
          </div>
        )}
        main={() => {
          return (
            <MainHome
              className="w-full"
              context={EnumContextGDT.GoldDate}
              widthICon={false}
            >
              {data && (
                <GoldListContainer
                  dataProps={data}
                  isDesktop={isDesktop}
                  isMobile={isMobile}
                />
              )}
            </MainHome>
          );
        }}
        mobile={{
          leftContent: {
            showMenuAction: true,
            items: true,
          },
          centerContent: { title: 'Fecha de Oro' },
        }}
        withBanners={true}
      />

      {/* MODAL INFO */}
      <Modal
        className="w-[600px] text-center px-[38px]"
        controlledOnClose={() => {
          updateTourney({ showModalInfo: false });
        }}
        disableBodyScroll={true}
        isControlledOpen={Boolean(tourneyData.showModalInfo) && isDesktop}
        render={() => <InfoContent />}
        size="sm"
        variant="controlled"
      />

      {/* MODAL CBU */}
      <ModalCBU />
    </>
  );
};
